module.exports = __webpack_public_path__ + "img/16581251_L.ed229a35.png";